import { CSS_BREAKPOINTS } from '@sbercloud/uikit-product-utils';
import styles from "./styles.module.css";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function HeroSlideImageBg(_ref) {
  var source = _ref.source;
  return /*#__PURE__*/_jsxs("picture", {
    className: styles.backgroundImageWrapper,
    children: [/*#__PURE__*/_jsx("source", {
      srcSet: source.mobile,
      media: CSS_BREAKPOINTS.mobile
    }), /*#__PURE__*/_jsx("source", {
      srcSet: source.tablet,
      media: CSS_BREAKPOINTS.tablet
    }), source.desktopLg ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("source", {
        srcSet: source.desktop,
        media: CSS_BREAKPOINTS.desktop
      }), /*#__PURE__*/_jsx("source", {
        srcSet: source.desktopLg
      })]
    }) : /*#__PURE__*/_jsx("source", {
      srcSet: source.desktop
    }), /*#__PURE__*/_jsx("img", {
      loading: "lazy",
      src: source.desktop,
      className: styles.backgroundImage,
      alt: "background"
    })]
  });
}